/**
 * Created by chenzheyu on 2017/6/21.
 */
import Vue from 'vue'
import InitData from '../store/configure'

export default {
  banner (obj, callback) {
    var params = {
      'app_key': InitData.appKey,
      'serviceType': obj.type
    }
    var url = InitData.serverUrl + '/news/weixin'
    Vue.http.get(url, {params}).then(
      data => {
        callback(data.body, obj.type)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/banner.js